/**
 * Careers list helper
 *
 * @since   1.0.0
 * @package blujay
 */

(function($) {
    $(document).ready(function() {

        var $careers_list = $( 'ul.careers-listing' );

        // Sanity check
        if ( $careers_list.length < 1 ) return;

        var $title_area = $( '.careers-title' );
        var $location_filter = $( 'select', $title_area );

        //add select2 to filter

        $location_filter.select2({
            minimumResultsForSearch : Infinity,
            dropdownCssClass : 'filters',
            width : '300px',
        });

        // Bind filter change
        if ( $location_filter.length ) {
            $location_filter.on( 'change', changeLocation );
        }

        // Bind job details button
        $( '.link a', $careers_list ).on( 'click', toggleJobDetails );

        /**
         * Handle location filter change
         *
         * @since 1.0.0
         */
        function changeLocation() {

            var new_location = $location_filter.val();

            if ( new_location == 'all' ) {
                showAllJobs();

                return;
            }

            hideAllJobs();

            $careers_list
                .children()
                .filter( function() {
                    return $( this ).data( 'location' ) === new_location;
                })
                .show();
        }

        /**
         * Handle showing / hiding job details
         *
         * @since 1.0.0
         */
        function toggleJobDetails( e ) {
            e.preventDefault();

            var $job = $( this ).parents( '.job' );
            var $target_content = $( '.content', $job );

            $( '.content', $careers_list ).not( $target_content ).hide();

            $target_content.toggle();

            if ( $target_content.is(':visible')) {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $job.offset().top
                }, 250);
            }
        }

        /**
         * Hide all jobs
         *
         * @since  1.0.0
         */
        function hideAllJobs() {
            $careers_list
                .children()
                .hide();
        }

        /**
         * Show all jobs
         *
         * @since  1.0.0
         */
        function showAllJobs() {
            $careers_list
                .children()
                .show();
        }

    }); // document.ready
})(jQuery);
